module.exports = __webpack_public_path__ + "static/img/5.a0e349e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/app/5.png
// module id = kShe
// module chunks = 1